import { createContext } from 'react'

const ItemsContext = createContext({ store: null })

export default ItemsContext
